import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "page-loader",
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  id: "a",
  x1: "8.042%",
  y1: "0%",
  x2: "65.682%",
  y2: "23.865%"
}
const _hoisted_3 = ["stop-color"]
const _hoisted_4 = ["stop-color"]
const _hoisted_5 = ["stop-color"]
const _hoisted_6 = {
  fill: "none",
  "fill-rule": "evenodd"
}
const _hoisted_7 = { transform: "translate(1 1)" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", {
  id: "Oval-2",
  d: "M36 18c0-9.94-8.06-18-18-18",
  stroke: "url(#a)",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "0.9s",
    repeatCount: "indefinite"
  })
], -1 /* HOISTED */)
const _hoisted_9 = ["fill"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 18 18",
  to: "360 18 18",
  dur: "0.9s",
  repeatCount: "indefinite"
}, null, -1 /* HOISTED */)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-loader-wrapper", {
			'page-loader-wrapper--small': $props.small,
			'page-loader-wrapper--smaller': $props.smaller
		}])
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, [
      _createElementVNode("defs", null, [
        _createElementVNode("linearGradient", _hoisted_2, [
          _createElementVNode("stop", {
            "stop-color": $props.invertColours ? '#fff' : '#1D2121',
            "stop-opacity": "0",
            offset: "0%"
          }, null, 8 /* PROPS */, _hoisted_3),
          _createElementVNode("stop", {
            "stop-color": $props.invertColours ? '#fff' : '#1D2121',
            "stop-opacity": ".631",
            offset: "63.146%"
          }, null, 8 /* PROPS */, _hoisted_4),
          _createElementVNode("stop", {
            "stop-color": $props.invertColours ? '#fff' : '#1D2121',
            offset: "100%"
          }, null, 8 /* PROPS */, _hoisted_5)
        ])
      ]),
      _createElementVNode("g", _hoisted_6, [
        _createElementVNode("g", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("circle", {
            fill: $props.invertColours ? '#fff' : '#1D2121',
            cx: "36",
            cy: "18",
            r: "1"
          }, _hoisted_11, 8 /* PROPS */, _hoisted_9)
        ])
      ])
    ]))
  ], 2 /* CLASS */))
}